// Form is based on Formik
// Data validation is based on Yup
// Please, be familiar with article first:
// https://hackernoon.com/react-form-validation-with-formik-and-yup-8b76bda62e10
import React, { useEffect } from "react";
import { Modal } from "react-bootstrap";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { Select } from "../../../../../_metronic/_partials/controls";
import { shallowEqual, useSelector } from "react-redux";

// Validation schema
const ProviderEditSchema = Yup.object().shape({});

export function ProviderEditStatusForm({
  saveProvider,
  provider,
  actionsLoading,
  onHide,
}) {
  // Getting current state of organisations list from store (Redux)
  const { currentState } = useSelector(
    (state) => ({ currentState: state.organisations }),
    shallowEqual
  );

  const { totalCount, entities, listLoading } = currentState;

  return (
    <>
      <Formik
        enableReinitialize={true}
        initialValues={provider}
        validationSchema={ProviderEditSchema}
        onSubmit={(values) => {
          values.organisation = { id: values?.organisation?.id };
          saveProvider(values);
        }}
      >
        {({ handleSubmit }) => (
          <>
            <Modal.Body className="overlay overlay-block cursor-default">
              {actionsLoading && (
                <div className="overlay-layer bg-transparent">
                  <div className="spinner spinner-lg spinner-success" />
                </div>
              )}
              <Form className="form form-label-right">
                <div className="form-group row">
                  {/* Status */}
                  <div className="col-lg-12">
                    <Select name="status" label="Status">
                      <option value="active">Active</option>
                      <option value="blocked">Blocked</option>
                      <option value="pending">Pending</option>
                      <option value="pending_reminder">Pending Reminder</option>
                      <option value="rejected">Rejected</option>
                    </Select>
                  </div>
                </div>

                <div className="form-group row">
                  {/* Status */}
                  <div className="col-lg-12">
                    <Select name="organisation.id" label="Organisation">
                      {entities?.map((res) => (
                        <option value={res?.id} key={res?.id}>
                          {res?.name}
                        </option>
                      ))}
                    </Select>
                  </div>
                </div>
              </Form>
            </Modal.Body>
            <Modal.Footer>
              <button
                type="button"
                onClick={onHide}
                className="btn btn-light btn-elevate"
              >
                Cancel
              </button>
              <> </>
              <button
                type="submit"
                onClick={() => handleSubmit()}
                className="btn btn-primary btn-elevate"
              >
                Save
              </button>
            </Modal.Footer>
          </>
        )}
      </Formik>
    </>
  );
}
